import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { JustinoService } from '../../../services/justino.service';
import { JustinoResponseDto } from '../../../dto/justino/justino-response.dto';
import { MessageDto } from '../../../dto/justino/message.dto';
import { catchError, of, Subscription, SubscriptionLike } from 'rxjs';
import { JustinoRequestDto } from '../../../dto/justino/justino-request.dto';
import { ConversationDto } from '../../../dto/justino/conversation.dto';
import { ViewEncapsulation } from '@angular/core';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ModalEditarTituloComponent } from '../modal-editar-titulo/modal-editar-titulo.component';
import { MiddlewareService } from '../../../services/middleware.service';
import { Constants } from '../../../constants/constants';
import { ListasService } from '../../../services/listas.service';
import { TramiteService } from '../../../services/tramite.service';
import { Tramite } from '../../tramites/models/entidadDTO';
import { JustinoHistoryDto } from '../../../dto/justino/justino-history.dto';
import { JustinoControlAccesoService } from '../../../services/justino-control-acceso.service';


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ChatComponent implements OnInit, OnDestroy {
  activeIndex = 0;
  version: string = '';
  message!: MessageDto;
  justinoActive = true;
  reasoning: string = '';
  processId: string = '';
  processPath: string = '';
  isLogo: boolean = false;
  tituloConv: string = '';
  newMessage: string = '';
  htmlElementFlag = false;
  htmlElement: string = '';
  isSurvey: boolean = false;
  collapsed: boolean = false;
  isThought: boolean = false;
  messages: MessageDto[] = [];
  nombresConv: string[] = [];
  generating: boolean = false;
  isReasoning: boolean = false;
  isShowSurvey: boolean = false;
  isAuthenticated: boolean = false;
  isDownloadBtn: boolean = false;
  isSidebarCollapsed: boolean = false;
  historyMessages: ConversationDto[] = [];
  conversation: ConversationDto | null = null;
  private actionReviewSubscription!: Subscription;
  private subscription: Subscription | null = null;
  private eventSourceSubscription!: SubscriptionLike;

  tramitesSupersalud: Tramite[] = []
  tramitesSic: Tramite[] = []

  // Define el flag del modal
  modalNDFlag: boolean = false;
  entidades: any[] = [];
  
  // Trackear estado de like/dislike por mensaje
  messageFeedback: Map<string, 'like' | 'dislike' | null> = new Map();

  @ViewChild(ModalEditarTituloComponent)
  modalND!: ModalEditarTituloComponent;

  @ViewChild('messageInput') messageInput!: ElementRef;
  @ViewChild('messagesContainer') messagesContainer!: ElementRef;

  @Input() userID!: string;
  @Input() sessionID!: string;

  constructor(
    private router: Router,
    private listaService: ListasService,
    private justinoService: JustinoService,
    private alertService: AlertaModalService,
    private middlewareService: MiddlewareService,
    private readonly tramiteService: TramiteService,
    private justinoControlAccesoService: JustinoControlAccesoService
  ) { }

  ngOnInit(): void {
    // Verifica si Justino está activo
    if (this.userID) {
      this.justinoControlAccesoService.checkAccess("").subscribe({
        next: (response: boolean) => {
          this.justinoActive = response;
        },
        error: (error) => {
          this.justinoActive = false;
        }
      });
    } else {
      this.justinoActive = false;
    }
    // Lista de entidades
    if (this.userID) {
      this.listaService.getEntidades().subscribe(entidades => {
        this.entidades = entidades.map(entidad => ({
          Id: entidad.Id ?? '',
          Nombre: entidad.Entidad || '',
          Acronimo: entidad.Acronimo || '',
          Logo: entidad.Logo || '',
        }));
      });
    }
    this.version = Constants.JUSTINO_VERSION;
    if (this.userID) {
      this.isAuthenticated = true;
      this.loadHistory();
    } else {
      this.justinoService
        .getPublicSession()
        .subscribe((response: any) => {
          if (response.status === "OK") {
            this.sessionID = response.session_id;
          }
        });
      let msg: MessageDto = {
        messageId: '',
        text: '',
        user: false,
        html: 'intro',
      };
      this.messages.push(msg);
      setTimeout(() => this.scrollToBottom(), 100);
    }
    this.actionReviewSubscription = this.middlewareService.actionReview$.subscribe(() => this.showReview());
  }

  updateProcess() {
    if (this.conversation?.sterotype) {
      this.isDownloadBtn = true;
      if (this.conversation?.form) {
        let ent = null;
        let nombreTramite = null;
        let nombreCorto = null;
        if (this.conversation?.form.includes('supersalud')) {
          ent = this.entidades.find(
            entidad => entidad.Id == Constants.ID_ENTIDAD_SUPERSALUD
          );
          nombreTramite = ent.Nombre;
          nombreCorto = ent.Acronimo;
          if (this.conversation?.sterotype.includes('Cobertura')) {
            nombreTramite = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('Cobertura'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('Cobertura'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Devoluciones')) {
            nombreTramite = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('devoluciones'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('devoluciones'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Entidades')) {
            nombreTramite = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('Entidades'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('Entidades'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Libre')) {
            nombreTramite = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('libre'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('libre'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Multiafiliación')) {
            nombreTramite = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('multiafiliación'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('multiafiliación'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Económico')) {
            nombreTramite = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('económico'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSupersalud.find(t => t.Nombre_Completo.includes('económico'))?.Nombre_Corto ?? nombreCorto;
          }
        } else if (this.conversation?.form.includes('sic')) {
          ent = this.entidades.find(
            entidad => entidad.Id == Constants.ID_ENTIDAD_SIC
          );
          nombreTramite = ent.Nombre;
          nombreCorto = ent.Acronimo;
          if (this.conversation?.sterotype.includes('Desleal') && this.conversation?.sterotype.includes('Propiedad')) {
            nombreTramite = this.tramitesSic.find(t => t.Nombre_Completo.includes('Desleal'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSic.find(t => t.Nombre_Completo.includes('Desleal'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Consumidores')) {
            nombreTramite = this.tramitesSic.find(t => t.Nombre_Completo.includes('Consumidores'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSic.find(t => t.Nombre_Completo.includes('Consumidores'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Propiedad')) {
            nombreTramite = this.tramitesSic.find(t => t.Nombre_Completo.includes('Propiedad'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSic.find(t => t.Nombre_Completo.includes('Propiedad'))?.Nombre_Corto ?? nombreCorto;
          } else if (this.conversation?.sterotype.includes('Desleal')) {
            nombreTramite = this.tramitesSic.find(t => t.Nombre_Completo.includes('Desleal'))?.Nombre_Completo ?? nombreTramite;
            nombreCorto = this.tramitesSic.find(t => t.Nombre_Completo.includes('Desleal'))?.Nombre_Corto ?? nombreCorto;
          }
        }
        if (ent) {
          sessionStorage.setItem('tramiteSeleccionado', nombreCorto);
          sessionStorage.setItem('nombreTramite', nombreTramite);
        }
      }
    }
  }

  loadHistory() {
    if (this.userID) {
      this.tramiteService.listaEntidadesYTramites().subscribe(resp => {
        this.tramitesSupersalud.push(
          ...(resp.find(
            entidad =>
              entidad.Id == Constants.ID_ENTIDAD_SUPERSALUD
          )?.Tipo_Tramite ?? [])
        );
        this.tramitesSic.push(
          ...(resp.find(
            entidad =>
              entidad.Id == Constants.ID_ENTIDAD_SIC
          )?.Tipo_Tramite ?? [])
        );
        this.justinoService
          .getHistory(this.userID, this.sessionID)
          .subscribe((response: JustinoHistoryDto) => {
            let conversation: ConversationDto;
            const objConver = response.history;
            this.sessionID = response.sessionId;
            for (let i = 0; i < objConver.length; i++) {
              conversation = {
                conversationId: objConver[i].conversation_id,
                name: objConver[i].name,
                messages: [],
                sterotype: objConver[i].sterotype,
                form: objConver[i].form,
                date: objConver[i].date,
                tramite: objConver[i].tramite,
                stage: objConver[i].stage
              };
              for (let j = 0; j < objConver[i].messages.length; j++) {
                let msg: MessageDto = {
                  messageId: objConver[i].messages[j].messageId,
                  text: objConver[i].messages[j].text,
                  user: objConver[i].messages[j].user,
                  html: objConver[i].messages[j].html,
                };
                conversation.messages.push(msg);
                // Actualiza el feedback del mensaje
                if (objConver[i].messages[j].feedback) {
                  this.messageFeedback.set(
                    objConver[i].messages[j].messageId,
                    objConver[i].messages[j].feedback
                  );
                }
              }
              this.historyMessages.push(conversation);
            }
            // Verifica si no existe historial de mensajes
            if (this.historyMessages.length === 0) {
              let msg: MessageDto = {
                messageId: '',
                text: '',
                user: false,
                html: 'intro',
              };
              this.messages.push(msg);
              setTimeout(() => this.scrollToBottom(), 100);
            } else {
              this.conversation = this.historyMessages[0];
              this.processId = this.conversation?.form ?? '';
              this.processPath = this.conversation?.form ?? '';
              this.messages = [...this.conversation.messages];
              setTimeout(() => this.scrollToBottom(), 100);
              this.updateProcess();
            }
          });
      });
    }
  }

  minifyHtml(html: string): string {
    return (
      html
        // 1. Colapsa cualquier secuencia de >1 espacio/tab/salto en un solo espacio
        .replace(/\s{2,}/g, ' ')
        // 2. Quita espacios entre las etiquetas:  >   <  → ><
        .replace(/>\s+</g, '><')
        // 3. Elimina espacio justo después del <
        .replace(/<\s+/g, '<')
        // 4. Elimina espacio justo antes del >
        .replace(/\s+>/g, '>')
        .trim()
    );
  }

  focusInput() {
    setTimeout(() => {
      if (this.messageInput && !this.generating) {
        this.messageInput.nativeElement.focus();
      }
    }, 50);
  }

  sendMessage() {
    if (this.newMessage.trim()) {
      const msgId = Math.random().toString(36);
      this.message = {
        messageId: msgId,
        text: this.newMessage,
        user: true,
        html: '',
      };
      this.conversation?.messages.push(this.message);
      this.messages.push(this.message);
      this.generating = true;
      this.isThought = true;
      setTimeout(() => this.scrollToBottom(), 100);
      this.eventSourceSubscription = this.justinoService
        .suscribeWebhook(this.sessionID)
        .subscribe({
          next: data => {
            setTimeout(() => {
              // Check if the length of the reasoning is greater than 300
              if (this.reasoning.length > 323 || data.chunk.length > 323) {
                this.reasoning = '';
              }
              let text = data.chunk;
              if (text.length > 323) {
                text = text.substring(0, 323);
              }
              this.reasoning += ` ${text}`;
            }, 500);
          },
          error: error => {
            console.log('Error: ', error);
          },
        });
      //-----------------------------------
      // Send message to Justino
      const dto: JustinoRequestDto = {
        userId: this.userID,
        sessionId: this.sessionID,
        conversationId: this.conversation?.conversationId ?? '',
        messageId: msgId,
        message: this.newMessage,
      };
      this.isReasoning = true;
      this.reasoning = '';
      this.subscription = this.justinoService.sendMessage(dto).subscribe({
        next: (response: JustinoResponseDto) => {
          if (this.message && this.message.messageId === response.messageId) {
            this.isThought = false;
            if (
              response.command === 'msg' ||
              response.command === 'msg-start' ||
              response.command === 'error' ||
              response.command === 'form-msg'
            ) {
              setTimeout(() => {
                this.message.text += ` ${response.chunk}`;
              }, 500);
            } else {
              if (response.chunk == 'END') {
                this.htmlElement = this.minifyHtml(this.htmlElement);
                this.htmlElementFlag = true;
              } else {
                this.htmlElement += response.chunk;
                setTimeout(() => {
                  // Verifica la longitud del texto
                  if (this.message.text.length % 100) {
                    this.message.text += '.\n';
                  } else {
                    this.message.text += '.';
                  }
                }, 500);
              }
            }
          } else {
            if (response.command === 'msg') {
              this.message = {
                messageId: response.messageId,
                text: response.chunk,
                user: false,
                html: '',
              };
              this.messages.push(this.message);
              this.conversation?.messages.push(this.message);
            } else if (response.command === 'msg-start') {
              const date = new Date();
              const options: Intl.DateTimeFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              };
              const dateString = date.toLocaleDateString('es-ES', options);
              this.conversation = {
                conversationId: response.conversationId,
                name: this.message.text,
                messages: [this.message],
                date: dateString,
              };
              this.historyMessages.unshift(this.conversation);
              this.message = {
                messageId: response.messageId,
                text: response.chunk,
                user: false,
                html: '',
              };
              this.messages.push(this.message);
              this.conversation.messages.push(this.message);
            } else if (response.command === 'error') {
              if (response.status == 401) {
                this.stopGenerating();
                this.redirectLogin();
              } else {
                this.message = {
                  messageId: '',
                  text: response.messageError,
                  user: false,
                  html: '',
                };
                this.messages.push(this.message);
                this.stopGenerating();
              }
            } else if (response.command === 'html') {
              this.htmlElementFlag = false;
              this.htmlElement = response.chunk;
              this.message = {
                messageId: response.messageId,
                text: 'Repondiendo a tu consulta. Por favor, espera',
                user: false,
                html: 'tabla',
              };
              this.messages.push(this.message);
              this.conversation?.messages.push(this.message);
            } else if (response.command === 'form-msg') {
              if (this.isAuthenticated) {
                let logoText = '';
                this.processId = response.form ?? '';
                this.processPath = response.form ?? '';

                if (this.processId && this.processId.includes('ica')) {
                  this.processId = 'ica';
                } else if (this.processId && this.processId.includes('superfinanciera')) {
                  this.processId = 'sfc';
                } else if (this.processId && this.processId.includes('sic')) {
                  this.processId = 'sic';
                } else if (this.processId && this.processId.includes('supersalud')) {
                  this.processId = 'sns';
                } else if (this.processId && this.processId.includes('supersociedades')) {
                  this.processId = 'supersociedades';
                } else if (this.processId && this.processId.includes('dimar')) {
                  this.processId = 'dimar';
                } else if (this.processId && this.processId.includes('dnda')) {
                  this.processId = 'dnda';
                } else {
                  this.processId = '';
                }

                let ent = null;
                let logoSrc = null;

                switch (this.processId) {
                  case 'dimar':
                    ent = this.entidades.find(
                      entidad => entidad.Id == Constants.ID_ENTIDAD_DIMAR
                    );
                    logoSrc = ent?.Logo ?? '';
                    logoText = `<p>Analizando DIMAR...</p><div class="dimarbox" style="background-image: url('${logoSrc}')"></div>`;
                    break;
                  case 'dnda':
                    ent = this.entidades.find(
                      entidad => entidad.Id == Constants.ID_ENTIDAD_DNDA
                    );
                    logoSrc = ent?.Logo ?? '';
                    logoText = `<p>Analizando DNDA...</p><div class="dndabox" style="background-image: url('${logoSrc}')"></div>`;
                    break;
                  case 'sfc':
                    ent = this.entidades.find(
                      entidad => entidad.Id == Constants.ID_ENTIDAD_SUPERFINANCIERA
                    );
                    logoSrc = ent?.Logo ?? '';
                    logoText = `<p>Analizando SFC...</p><div class="sfcbox" style="background-image: url('${logoSrc}')"></div>`;
                    break;
                  case 'ica':
                    ent = this.entidades.find(
                      entidad => entidad.Id == Constants.ID_ENTIDAD_ICA
                    );
                    logoSrc = ent?.Logo ?? '';
                    logoText = `<p>Analizando ICA...</p><div class="icabox" style="background-image: url('${logoSrc}')"></div>`;
                    break;
                  case 'sic':
                    ent = this.entidades.find(
                      entidad => entidad.Id == Constants.ID_ENTIDAD_SIC
                    );
                    logoSrc = ent?.Logo ?? '';
                    logoText = `<p>Analizando SIC...</p><div class="sicbox" style="background-image: url('${logoSrc}')"></div>`;
                    break;
                  case 'sns':
                    ent = this.entidades.find(
                      entidad => entidad.Id == Constants.ID_ENTIDAD_SUPERSALUD
                    );
                    logoSrc = ent?.Logo ?? '';
                    logoText = `<p>Analizando SNS...</p><div class="snsbox" style="background-image: url('${logoSrc}')"></div>`;
                    break;
                  case 'supersociedades':
                    ent = this.entidades.find(
                      entidad => entidad.Id == Constants.ID_ENTIDAD_SUPER_SOCIEDADES
                    );
                    logoSrc = ent?.Logo ?? '';
                    logoText = `<p>Analizando Supersociedades...</p><div class="ssobox" style="background-image: url('${logoSrc}')"></div>`;
                    break;
                }
                if (this.processId && !this.isLogo) {
                  this.isLogo = true;
                  let message = {
                    messageId: '',
                    text: logoText,
                    user: false,
                    html: 'logo',
                  };
                  this.messages.push(message);
                  this.conversation?.messages.push(message);
                }

                this.message = {
                  messageId: response.messageId,
                  text: response.chunk,
                  user: false,
                  html: '',
                };
                this.messages.push(this.message);
                this.conversation?.messages.push(this.message);
                this.isDownloadBtn = true;

                this.conversation!.sterotype = response.form ?? '';
                this.conversation!.form = response.form ?? '';

                if (response.stage) {
                  this.conversation!.stage = response.stage;
                }
              } else {
                this.stopGenerating();
                this.isDownloadBtn = false;
                this.processId = '';
                this.processPath = '';
                //this.messages = [];
                this.message = {
                  messageId: response.messageId,
                  text: 'Para continuar, debes iniciar sesión.',
                  user: false,
                  html: 'login',
                };
                this.messages.push(this.message);
                this.conversation?.messages.push(this.message);
              }

              // Actualiza el proceso en curso
              this.updateProcess();
            } else {
              this.isReasoning = false;
              this.stopGenerating();
            }
          }
          setTimeout(() => this.scrollToBottom(), 100);
        },
        error: error => {
          this.generating = false;
          this.isThought = false;
          this.focusInput();
        },
        complete: () => {
          this.generating = false;
          this.isThought = false;
          this.focusInput();
        },
      });
      this.newMessage = '';
    }
  }

  onEnterKey(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;

    // Si se presiona Shift + Enter, permitir salto de línea
    if (keyboardEvent.shiftKey) {
      return; // No hacer nada, permitir el comportamiento por defecto
    }

    // Si solo se presiona Enter, enviar el mensaje
    keyboardEvent.preventDefault(); // Previene que se agregue el Enter al texto
    this.sendMessage();
  }

  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  scrollToBottom() {
    if (this.messagesContainer) {
      this.messagesContainer.nativeElement.scrollTop =
        this.messagesContainer.nativeElement.scrollHeight;
    }
  }

  setActiveIndex(index: number) {
    this.activeIndex = index;
  }

  toggleSidebar() {
    if (this.isSidebarCollapsed) {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
      setTimeout(() => {
        this.collapsed = this.isSidebarCollapsed;
      }, 500);
    } else {
      this.collapsed = !this.collapsed;
      setTimeout(() => {
        this.isSidebarCollapsed = this.collapsed;
      }, 500);
    }
  }

  newQuery() {
    if (this.historyMessages.length >= Constants.CANTIDAD_CONVERSACIONES_HISTORIAL) {
      this.alertService.advertencia(
        'Límite de conversaciones alcanzado',
        `No puedes crear más de ${Constants.CANTIDAD_CONVERSACIONES_HISTORIAL} conversaciones. Por favor, elimina una conversación para crear una nueva.`
      );
      return;
    } else {
      this.isDownloadBtn = false;
      this.conversation = null;
      this.messages = [];
      this.messages.push({
        messageId: '',
        text: '',
        user: false,
        html: 'intro',
      });
      setTimeout(() => this.scrollToBottom(), 100);
    }
  }

  entidadSeleccionada(message: string) {
    this.newMessage = message;
    this.sendMessage();
  }

  stopGenerating() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.generating = false;
    this.isThought = false;
    this.isReasoning = false;
    this.focusInput();
    if (this.eventSourceSubscription) {
      this.eventSourceSubscription.unsubscribe();
      this.justinoService.close();
    }
  }

  loadConversation(conversation: ConversationDto) {
    this.isLogo = false;
    this.conversation = conversation;
    this.messages = [...conversation.messages];
    if (this.conversation?.sterotype) {
      this.isDownloadBtn = true;
      this.processId = this.conversation?.form ?? '';
      this.processPath = this.conversation?.form ?? '';
    } else {
      this.isDownloadBtn = false;
      this.processId = '';
      this.processPath = '';
    }
    setTimeout(() => this.scrollToBottom(), 100);
  }

  abrirModalND() {
    this.modalNDFlag = true;
    setTimeout(() => {
      this.modalND.abrirCerrarModal();
    }, 500);
  }

  editConversation(conversation: ConversationDto) {
    this.conversation = conversation;
    this.tituloConv = conversation.name;
    this.nombresConv = this.historyMessages.map(
      conversation => conversation.name
    );
    this.abrirModalND();
  }

  registrarTitulo(dto: any) {
    if (this.conversation) {
      this.justinoService
        .updateConversation(this.conversation.conversationId, dto.titulo)
        .pipe(
          catchError(error => {
            this.alertService.error(
              'Error al actualizar el título de la conversación'
            );
            return of(null);
          })
        )
        .subscribe(result => {
          if (result === null) {
            return;
          }
          // Lógica en caso de éxito
          this.alertService.exito('El título se ha actualizado correctamente');
          this.modalNDFlag = false;
          const index = this.historyMessages.findIndex(
            conversation =>
              conversation.conversationId === this.conversation?.conversationId
          );
          this.conversation!.name = dto.titulo;
          this.historyMessages[index].name = dto.titulo;
        });
    }
  }

  deleteConversation(conversation: ConversationDto) {
    // Muestra alerta de confirmación
    this.alertService.confirmacion(
      '¿Estás seguro de que deseas eliminar ésta conversación?',
      'Eliminar conversación',
      () => {
        // Elimina la conversación
        this.justinoService
          .deleteConversation(conversation.conversationId)
          .subscribe(() => {
            // Elimina la conversación de la lista
            const index = this.historyMessages.indexOf(conversation);
            if (index > -1) {
              this.historyMessages.splice(index, 1);
            }
            this.alertService.exito(
              'La conversación se ha eliminado correctamente'
            );
            this.newQuery();
          });
      },
      () => {
        // Acción de cancelar
        this.alertService.advertencia(
          'Acción cancelada',
          'La conversación no ha sido eliminada'
        );
      },
      true
    );
  }

  formatMessage(text: string): string {
    // Replace **word** with <b>word</b>
    let formattedText = text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    // Replace \n with <br>
    formattedText = formattedText.replace(/\n/g, '<br>');
    formattedText = formattedText
      // 1. Elimina espacio justo después del ?
      .replace(/\¿\s+/g, '¿')
      // 2. Elimina espacio justo antes del ?
      .replace(/\s+\?/g, '?')
      // 3. Elimina espacio justo después del ¡
      .replace(/\¡\s+/g, '¡')
      // 4. Elimina espacio justo antes del !
      .replace(/\s+\!/g, '!')
      // 5. Elimina espacio justo antes del .
      .replace(/\s+\./g, '.')
      // 6. Elimina espacio justo antes del ,
      .replace(/\s+\,/g, ',')
      // 7. Elimina espacio justo antes del :
      .replace(/\s+\:/g, ':')
      // 9. Elimina espacio justo antes del /
      .replace(/\s+\//g, '/')
      // 10. Elimina espacio justo después del /
      .replace(/\/\s+/g, '/')
      .trim()
    return formattedText;
  }

  downloadDoc(): void {
    this.justinoService
      .download(this.conversation?.conversationId ?? '', this.sessionID)
      .subscribe(
        blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Borrador.docx`;
          a.click();
          window.URL.revokeObjectURL(url);
          this.alertService.exito(
            'El documento se ha descargado correctamente'
          );
        },
        error => {
          this.alertService.error('Error al descargar el documento');
        }
      );
  }

  redirectLogin() {
    this.router.navigateByUrl(Constants.JUSTINO_RUTA_LOGIN);
  }

  async showReview() {
    if (!this.isSurvey) {
      this.isSurvey = true;
      this.alertService.confirmacion(
        'Gracias por interactuar con Justino, esperamos haya sido de ayuda la consulta.\n\n¿Desea realizar una breve encuesta de satisfacción?\n\nLas respuestas recopiladas nos ayudarán a mejorar el servicio.',
        'Encuesta de satisfacción',
        () => {
          this.isShowSurvey = true;
        },
        () => {
          this.router.navigateByUrl(Constants.JUSTINO_RUTA_TRAMITES);
          if (this.isDownloadBtn) {
            const url = `${Constants.JUSTINO_RUTA_TRAMITES}/${this.processPath}`;
            this.router.navigateByUrl(url);
          } else {
            this.router.navigateByUrl(Constants.JUSTINO_RUTA_TRAMITES);
          }
        },
        true
      );
    } else {
      if (this.isDownloadBtn) {
        const url = `${Constants.JUSTINO_RUTA_TRAMITES}/${this.processPath}`;
        await this.router.navigateByUrl(url);
      } else {
        await this.router.navigateByUrl(Constants.JUSTINO_RUTA_TRAMITES);
      }
    }
  }

  showWhastapp() {
    this.justinoService.getActivateToken(this.userID).subscribe((data: any) => {
      if (data && data.token_activacion) {
        const textoMensaje = `${Constants.JUSTINO_WHATSAPP_MSG_P1}${data.token_activacion}${Constants.JUSTINO_WHATSAPP_MSG_P2}`;
        const userData = JSON.parse(
          sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
        );
        const telefono = String(userData.telefonoPrincipal);
        const whatsappUrl = `https://wa.me/${telefono}?text=${textoMensaje}`;
        window.open(whatsappUrl, '_blank');
      }
      else {
        this.alertService.error('Error al obtener sesión de WhatsApp');
      }
    }, error => {
      this.alertService.error('Error al obtener sesión de WhatsApp');
    });
  }

  toggleLike(messageId: string): void {
    const currentFeedback = this.messageFeedback.get(messageId);
    if (currentFeedback === 'like') {
      this.messageFeedback.set(messageId, null);
    } else {
      this.messageFeedback.set(messageId, 'like');
    }
    this.justinoService.updateFeedback(this.conversation?.conversationId, messageId, 'like').subscribe();
  }

  toggleDislike(messageId: string): void {
    const currentFeedback = this.messageFeedback.get(messageId);
    if (currentFeedback === 'dislike') {
      this.messageFeedback.set(messageId, null);
    } else {
      this.messageFeedback.set(messageId, 'dislike');
    }
    this.justinoService.updateFeedback(this.conversation?.conversationId, messageId, 'dislike').subscribe();
  }

  getFeedbackStatus(messageId: string): 'like' | 'dislike' | null {
    return this.messageFeedback.get(messageId) || null;
  }

  onActualizar() {
    this.justinoActive = true;
  }

  ngOnDestroy() {
    if (this.actionReviewSubscription) {
      this.actionReviewSubscription.unsubscribe();
    }
    this.justinoService.close();
  }
}
